/**
 * Parse automation_instruction field from API into instruction rows.
 */
export function parseInstructionsFromApi(raw) {
    if (raw == null) return [];

    if (Array.isArray(raw) && raw.length > 0) {
        return raw
            .map((item, index) => ({
                id: typeof item?.id === 'number' || typeof item?.id === 'string' ? item.id : Date.now() + index,
                text: typeof item?.text === 'string' ? item.text : String(item?.text ?? ''),
                aiSteps: [],
            }))
            .filter((instr) => instr.text.trim() !== '');
    }

    if (typeof raw === 'string' && raw.trim()) {
        return raw
            .split('\n')
            .filter((text) => text.trim())
            .map((text, index) => ({
                id: Date.now() + index,
                text,
                aiSteps: [],
            }));
    }

    return [];
}

/**
 * Recover instruction rows from plan steps when automation_instruction is missing.
 */
export function recoverInstructionsFromPlanSteps(planSteps = []) {
    const seenIds = new Set();
    const instructions = [];

    for (const step of planSteps) {
        const instrId = step.instruction?.id ?? step.args?.instructionId ?? step.instructionId;
        const instrText = step.instruction?.text ?? '';
        if (instrId != null && !seenIds.has(String(instrId))) {
            seenIds.add(String(instrId));
            instructions.push({ id: instrId, text: instrText, aiSteps: [] });
        }
    }

    return instructions;
}
